import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import TutorialContainer from "../containers/TutorialContainer";
import AccordionNav from "../components/AccordionNav";
import { educationContent } from "../utils/TutorialContent";
import "./TutorialPage.css";

class TutorialPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
  }
  componentWillMount() {
    document.title = "Tutorial";
  }

  renderTutPage = (routerProps) => {
    let pageId = parseInt(routerProps.match.params.id);
    let foundPage = educationContent.pages.find(
      (pageObj) => pageObj.id === pageId
    );
    return foundPage ? (
      <TutorialContainer
        {...routerProps}
        page={foundPage}
        firstPage={foundPage.id === 1}
        lastPage={foundPage.id === educationContent.pages.length}
        changeCurrentPage={this.changeCurrentPage}
        className="border border-secondary"
      />
    ) : (
      <h2>404 page not found</h2>
    );
  };

  changeCurrentPage = (id) => {
    this.setState({
      currentPage: id,
    });
  };

  render() {
    return (
      <div className="container-fluid pt-4">
        <div className="row">
          <div className="col-md-3">
            <a name="skipnav" id="skipnav">
              <h1 className="text-center justify-content-center">Tutorial</h1>
            </a>
            <AccordionNav
              content={educationContent}
              currentPage={this.state.currentPage}
            />
          </div>
          <div className="col-md-9">
            <div className="row">
              <Switch>
                <Route
                  path={`${this.props.match.path}/:id`}
                  render={(routerProps) => this.renderTutPage(routerProps)}
                />
                <Redirect
                  from={this.props.match.path}
                  to={`${this.props.match.path}/1`}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TutorialPage;
